import { Component, OnInit, AfterViewInit, HostListener, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DatePipe } from '@angular/common';
import { PackageDataService } from '../../data-services/package.service';
import { LazyLoadEvent } from 'primeng/api';
import { SelectItem, MessageService } from 'primeng/api';
import { RequisitionDataService } from '../../data-services/requisition.service';
import { DialogService } from 'primeng/dynamicdialog';
import { DomSanitizer } from '@angular/platform-browser';
import { LabDataService } from '../../data-services/lab.service';
import { ActiveLabPanelDto } from '../../models/active-panel-dto';
import { LocalRequistionService } from '../../data-services/local-requisition.service';
import { ButtonModule } from 'primeng/button';
import { AccordionModule } from 'primeng/accordion';
import { FormsModule } from '@angular/forms';
import { Toast } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { DatePickerModule } from 'primeng/datepicker';
import { CheckboxModule } from 'primeng/checkbox';
import { HasClaimDirective } from '../../security/has-claim.directive';
import { SelectModule } from 'primeng/select';
import { ReceivingPackageComponent } from '../receiving-list/receiving.package';

interface FilterOption {
  value: number;
  label: string;
}

@Component({
  selector: 'app-package-list',
  templateUrl: './package.list.html',
  providers: [DialogService, MessageService],
  standalone: true,
  imports: [ButtonModule, AccordionModule, FormsModule, Toast, CommonModule, TableModule, DatePickerModule, CheckboxModule, HasClaimDirective, SelectModule, ReceivingPackageComponent]
})
export class PackageListComponent implements AfterViewInit, OnInit {

  @ViewChild('packageImage') packageImage;
  @ViewChild('packagelist') packageList;

  barcode = "";
  barcodeReading = false;

  constructor(private packageDataService: PackageDataService,
    private requisitionService: RequisitionDataService,
    public dialogService: DialogService,
    private router: Router,
    private route: ActivatedRoute,
    private datepipe: DatePipe,
    private messageService: MessageService,
    private labDataService: LabDataService,
    private localReqService: LocalRequistionService) {
    this.queryParams = this.router.routerState.snapshot.root.queryParams["includeExceptions"];
  }

  packages;
  statuses: SelectItem[] = [];
  facilities: SelectItem[] = [];
  testNames: SelectItem[] = [];
  totalRecords: number;
  cols: any[];
  includeExceptionsOptions: FilterOption[] = [
    { value: 0, label: "No Exceptions Filter" },
    { value: 1, label: "Only Packages With Exceptions" },
    { value: 2, label: "Only Packages Without Exceptions" }
  ];

  includeRejectionsOptions: FilterOption[] = [
    { value: 0, label: "No Rejections Filter" },
    { value: 1, label: "Only Packages With Rejections" },
    { value: 2, label: "Only Packages Without Rejections" }
  ];

  includeDateFilterOptions: FilterOption[] = [
    { value: 0, label: "No Date Filter" },
    { value: 1, label: "Only Packages In This Date Range" },
  ];

  includeExceptionsValue: FilterOption = this.includeExceptionsOptions[0];
  includeRejectionsValue: FilterOption = this.includeRejectionsOptions[0];
  includeDateFilterValue: FilterOption = this.includeDateFilterOptions[0];

  loading: boolean = false;
  processingExceptions: boolean = false;
  selectedStatus: SelectItem;
  filter: any = {};
  filterDisplay: string = "None";
  queryParams: string;
  sub: any;

  ngOnInit() {
    this.getLabPanels();


    this.cols = [
      { field: 'TrackingNumber', header: 'Tracking' },
      { field: 'FromName', header: 'From' },
      { field: 'ClientName', header: 'Client' },
      { field: 'DeliveredDate', header: 'Delivered' },
      { field: 'ReceivedDate', header: 'Received' },
      { field: 'OpenedDate', header: 'Opened' },
      { field: 'CompletedDate', header: 'Completed' },
      { field: 'RequisitionCount', header: 'Samples' },
      { field: 'RequisitionExceptionCount', header: 'Exceptions' },
      { field: 'RequisitionRejectCount', header: 'Rejects' },
    ];

    this.filter.IncludeExceptions = null;
    this.filter.IncludeRejections = null;
    this.filter.EndReceivedDate = null;
    this.filter.BeginReceivedDate = null;
    //this.filter.BeginReceivedDate.setDate(this.filter.BeginReceivedDate.getDate() - 5);
    this.filter.ClientIds = [];
    this.sub = this.route.params.subscribe((params: Params) => {
      this.searchTerm = params["accession"];

      this.filter.IncludeExceptions = params["includeExceptions"];
      this.setFilterDescription();
    });
    this.loading = true;
  }

  ngAfterViewInit() {
    if (this.searchTerm != undefined && this.searchTerm.length > 0) {
      this.packageList.filterGlobal(this.searchTerm, 'contains');
    }
  }

  searchTerm: string = "";
  public handleSearchKey(event, reqlist) {
    if (event.keyCode == 13) {
      this.includeExceptionsValue = this.includeExceptionsOptions[0];
      this.includeRejectionsValue = this.includeRejectionsOptions[0];
      this.includeDateFilterValue = this.includeDateFilterOptions[0];

      this.filter.IncludeExceptions = null;
      this.filter.IncludeRejections = null;
      this.filter.EndReceivedDate = new Date();
      this.filter.BeginReceivedDate = new Date();
      this.filter.BeginReceivedDate.setDate(this.filter.BeginReceivedDate.getDate() - 5);
      this.filter.ClientIds = [];
      reqlist.filterGlobal(event.target.value, 'contains');
      this.searchTerm = event.target.value;
      this.filterDisplay = this.searchTerm;
      event.preventDefault();
    }
  }

  lastLoad: LazyLoadEvent;
  public loadPackagesLazy(event: LazyLoadEvent) {
    console.log("load packages");
    if (this.searchTerm != undefined && this.searchTerm.length > 0 && event.filters.global == undefined) {
      return;
    }

    this.loading = true;

    if (event) {
      this.lastLoad = event;
    } else {
      this.lastLoad.first = 0;
      event = this.lastLoad;
    }
    this.packageDataService.getList(event.first, event.rows, event.sortField, event.sortOrder, event.filters, event.filters).subscribe((data: any) => {
      this.totalRecords = data.totalRows;
      this.packages = data.rows;

      if (this.packages.length == 1) {
        this.packages[0].showDetail = true;
      }
      else {
        for (var i = 0; i < this.packages.length; i++) {
          this.packages[i].showDetail = false;
        }
      }
      event.filters.global = {};
      this.loading = false;
    });
  }

  applyFilter() {
    this.setFilterDescription();
    this.loadPackagesLazy(null);
  }


  setFilterDescription() {
    this.filterDisplay = "";
    if (this.filter.IncludeExceptions) {
      this.filterDisplay = this.filterDisplay + "Exceptions ";
    } else if (this.filter.IncludeExceptions != null) {
      this.filterDisplay = this.filterDisplay + "Without Exceptions ";
    }
    if (this.filter.IncludeRejections) {
      this.filterDisplay = this.filterDisplay + "Rejections ";
    } else if (this.filter.IncludeRejections != null) {
      this.filterDisplay = this.filterDisplay + "Without Rejections ";
    }
    if (this.filter.BeginReceivedDate) {
      this.filterDisplay = this.filterDisplay + "After " + this.datepipe.transform(this.filter.BeginReceivedDate, 'MM/dd/yyyy') + " ";
    }
    if (this.filter.EndReceivedDate) {
      this.filterDisplay = this.filterDisplay + "Before " + this.datepipe.transform(this.filter.EndReceivedDate, 'MM/dd/yyyy') + " ";
    }

    if (!this.filterDisplay) {
      this.filterDisplay = "None";
    }
  }

  private getLabPanels() {
    this.labDataService.GetLabPanels().subscribe((data: ActiveLabPanelDto[]) => {
      if (data !== null) {
        console.log('active lab panel list ', data);
        this.localReqService.setActiveLabPanels(data);
      }
      this.loading = false;
    });
  }



  clearFilter() {
    this.filterDisplay = "None";
    this.filter.IncludeExceptions = null;
    this.filter.IncludeRejections = null;
    this.filter.EndReceivedDate = new Date();
    this.filter.BeginReceivedDate = new Date();
    this.filter.BeginReceivedDate.setDate(this.filter.BeginReceivedDate.getDate() - 5);
    this.filter.ClientIds = [];
    this.loadPackagesLazy(null);
  }

  public attemptToResolveRequisitionExceptions() {
    this.processingExceptions = true;
    this.requisitionService.attemptToResolveRequisitionExceptionsAll().subscribe((data: any) => {
      this.loadPackagesLazy(null);
      this.processingExceptions = false;
    },
      (err) => {
        this.messageService.add({ severity: 'error', summary: 'Attempt to Resolve Requisition Exceptions', detail: 'Error: ' + err.status });
        this.processingExceptions = false;
      });
  }

  public exceptionFilterChange(event: any) {
    console.log(event);
    switch (event.value.value) {
      case 0:
        this.filter.IncludeExceptions = null;
        break;
      case 1:
        this.filter.IncludeExceptions = true;
        break;
      case 2:
        this.filter.IncludeExceptions = false;
        break;
    }
    return;
  }

  public rejectionFilterChange(event: any) {
    console.log(event);
    switch (event.value.value) {
      case 0:
        this.filter.IncludeRejections = null;
        break;
      case 1:
        this.filter.IncludeRejections = true;
        break;
      case 2:
        this.filter.IncludeRejections = false;
        break;
    }
    return;
  }

  public dateFilterChange(event: any) {
    console.log(event);
    switch (event.value.value) {
      case 0:
        this.filter.EndReceivedDate = null;
        this.filter.BeginReceivedDate = null;
        break;
      case 1:
        this.filter.EndReceivedDate = new Date();
        this.filter.BeginReceivedDate = new Date();
        this.filter.BeginReceivedDate.setDate(this.filter.BeginReceivedDate.getDate() - 5);
        break;
    }

    return;
  }

  //public loadFilters() {
  //   this.packageDataService.getFilters().subscribe((data: any) => {
  //      this.statuses = [{ label: '', value: '' }];
  //      data.statuses.forEach((val) => {
  //         if (val != null && val.trim().length > 0) {
  //            this.statuses.push({
  //               label: val, value: val
  //            });
  //         }
  //      });
  //      this.facilities = [{ label: '', value: '' }];
  //      data.facilities.forEach((val) => {
  //         if (val != null && val.trim().length > 0) {
  //            this.facilities.push({
  //               label: val, value: val
  //            });
  //         }
  //      });
  //      this.testNames = [{ label: '', value: '' }];
  //      data.testNames.forEach((val) => {
  //         if (val != null && val.trim().length > 0) {
  //            this.testNames.push({
  //               label: val, value: val
  //            });
  //         }
  //      });
  //   });
  //}
}
